import z from "zod";
import { mediaItemId, projectsId, mediaVariantId, templateContentsId } from "../../db_gen";

const completeVariantUpload = z.object({
  uploadKey: z.string().min(1),
  mediaItemId: mediaItemId,
  format: z.string().min(1),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  quality: z.number().int().min(1).max(100).optional(),
  transformParams: z.unknown().optional(),
});

// Upload
const getPresigned = z.object({
  filename: z.string().min(1),
  mimeType: z.string().min(1),
  projectId: projectsId.optional(),
});

const complete = z.object({
  uploadKey: z.string().min(1),
  projectId: projectsId.optional(),
  name: z.string().min(1).optional(),
  tags: z.array(z.string()).optional(),
  alt: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  metadata: z.unknown().nullable().optional(),
});

// Items
const listItems = z.object({
  projectId: projectsId.optional(),
  tags: z.array(z.string()).optional(),
  cursor: z.string().optional(),
  limit: z.number().min(1).max(100).default(20),
});

const updateItem = z.object({
  mediaId: mediaItemId,
  data: z
    .object({
      name: z.string().min(1).optional(),
      tags: z.array(z.string()).optional(),
      alt: z.string().nullable().optional(),
      description: z.string().nullable().optional(),
      metadata: z.unknown().nullable().optional(),
    })
    .strict(),
});

const deleteItem = z.object({
  mediaId: mediaItemId,
});

const getPresignedVariantUpload = z.object({
  mediaItemId: mediaItemId,
  format: z.string().min(1),
  width: z.number().int().positive().optional(),
  height: z.number().int().positive().optional(),
  quality: z.number().int().min(1).max(100).optional(),
  transformParams: z.unknown().optional(),
});

// Usage
const trackUsage = z.object({
  mediaVariantId: mediaVariantId,
  templateContentId: templateContentsId,
});

const removeUsage = z.object({
  mediaVariantId: mediaVariantId,
  templateContentId: templateContentsId,
});

const getUsage = z.object({
  templateContentId: templateContentsId,
  mediaVariantId: mediaVariantId,
});

// Publishing
const publishForTemplateContent = z.object({
  templateContentId: templateContentsId,
});

const mediaSchemas = {
  upload: {
    getPresigned,
    complete,
  },
  items: {
    list: listItems,
    update: updateItem,
    delete: deleteItem,
  },
  variants: {
    getPresignedUpload: getPresignedVariantUpload,
    completeUpload: completeVariantUpload,
  },
  usage: {
    track: trackUsage,
    remove: removeUsage,
    get: getUsage,
  },
  publishing: {
    forTemplateContent: publishForTemplateContent,
  },
} as const;

export default mediaSchemas;
